module.exports = __webpack_public_path__ + "img/ipad.ea224a27.png";